// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import HeaderClickable from "@guestsupply/App/Components/Header/HeaderClickable";
import xngGaToolBarNavigationEvent from "@guestsupply/App/Handlers/GoogleAnalytics/ToolBarNavigation/ToolBarNavigationEvent";
import { customXngageWidget } from "@guestsupply/XDL/constants";
import LanguageIcon from "@guestsupply/XDL/Icons/Language";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    src = "src",
}

interface OwnProps {
    showAsLink?: boolean;
}
interface Props extends WidgetProps {
    fields: {
        [fields.src]: string;
    };
}

export interface LanguageStyles {
    link?: LinkPresentationProps;
}

// <xng-change>: add google event
const mapStateToProps = () => ({});

const mapDispatchToProps = {
    xngGaToolBarNavigationEvent,
};
// </xng-change>: add google event

export const languageStyles: LanguageStyles = {};

const styles = languageStyles;

// xng-change: add google event
type LanguageProps = Props & OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const Language: React.FC<LanguageProps> = ({
    fields,
    showAsLink = false,
    // xng-change: add google event
    xngGaToolBarNavigationEvent,
}) => {
    const onClickHandler = () => {
        const oldScript = document.getElementById("languageSelectorModal");
        oldScript?.nextElementSibling?.tagName === "LINK" ? oldScript?.nextSibling?.remove() : "";
        oldScript?.remove();
        const script = document.createElement("script");
        script.id = "languageSelectorModal";
        script.type = "text/javascript";
        script.src = fields.src;
        document.body.appendChild(script);

        // xng-change: add google event
        xngGaToolBarNavigationEvent({
            clickText: translate("Language"),
        });
    };

    return (
        <>
            {showAsLink ? (
                <Link
                    {...styles.link}
                    onClick={onClickHandler}
                    data-test-selector="Language"
                    className="main-navigation-row-text"
                >
                    {translate("Language")}
                </Link>
            ) : (
                <StyledWrapper data-test-selector="Language">
                    <HeaderClickable
                        onClick={onClickHandler}
                        iconProps={{ src: LanguageIcon }}
                        title={translate("Language")}
                    />
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(Language),
    definition: {
        displayName: "Language",
        group: customXngageWidget as any,
        fieldDefinitions: [
            {
                name: fields.src,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
